import { render } from "./Portfolio.vue?vue&type=template&id=56b67a9e&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=ts"
export * from "./Portfolio.vue?vue&type=script&lang=ts"

import "./Portfolio.vue?vue&type=style&index=0&id=56b67a9e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-56b67a9e"

export default script